<template>
    <div :class="['input-wrapper', 'form-input-select', { 'input-has-full-border': fullBorder, 'input-wrapper-mb-2x': marginBottomDouble, 'input-error-border': hasError, 'is-required': required, }]">
        <label v-if="label" :class="{ 'float-label-active': isFloatLabelActive, 'is-float-label': !withoutFloatLabel }">{{ label }}<span v-if="required">*</span></label>
        <select v-model="selectedItem" :name="name" :id="name" :title="title ? title : __('Choose')" :required="required" :data-none-results-text="__('Nothing found')" :disabled="noValues">
            <option v-for="(option, index) in options" :key="index" :value="option.value ? option.value : option.label">
                <div class="content">
                    <figure v-if="option.img">
                        <img :src="option.img" alt="">
                    </figure>
                    <span>{{ option.label }}</span>
                </div>
            </option>
        </select>

        <form-input-error v-if="hasError" :error="errors[0]"></form-input-error>
        <form-input-note v-else-if="note" :text="note"></form-input-note>
    </div>
</template>

<script>
    export default {
        props: {
            errors: {
                type: Array,
                required: false,
                default: null
            },

            name: {
                type: String,
                required: true
            },

            label: {
                type: String,
                required: false,
                default: null
            },

            options: {
                type: Array,
                required: true
            },

            required: {
                type: Boolean,
                required: false,
                default: false
            },

            fullBorder: {
                type: Boolean,
                required: false,
                default: false
            },

            note: {
                type: String,
                required: false,
                default: null
            },

            marginBottomDouble: {
                type: Boolean,
                required: false,
                default: false
            },

            value: {
                type: String,
                required: false,
                default: null
            },

            title: {
                type: String,
                required: false,
                default: null
            },

            withoutFloatLabel: {
                type: Boolean,
                required: false,
                default: false
            }
        },
        data() {
            return {
                selectedItem: this.value,
                hasError: false,
                isFloatLabelActive: false,
                noValues: this.options.length === 0 ? true : false
            }
        },

        watch: {
            errors: {
                immediate: true,
                handler(errors) {
                    if (errors === null || errors === undefined || errors.length === 0) {
                        this.hasError = false
                    } else {
                        this.hasError = true
                    } 
                }
            },

            value: {
                immediate: true,
                handler(value) {
                    this.selectedItem = value
                }
            },

            selectedItem() {
                if (this.selectedItem !== null) {
                    this.hasError = false
                    this.isFloatLabelActive = true
                } else {
                    this.isFloatLabelActive = false
                }
            },

            options() {
                this.noValues = this.options.length === 0 ? true : false
            }
        },

        mounted() {
            setTimeout(() => {
                $('#'+this.name).selectpicker({})

                if(this.value) {
                    $('#'+this.name).selectpicker('val', this.value);
                    this.isFloatLabelActive = true;

                    if (this.value === 'Rezeptanfrage PKV oder Selbstzahler') {
                        this.selectedItem = this.value
                    }
                }
            }, 100)
        },
    }
</script>
